module.exports = __webpack_public_path__ + "img/H5-6.ebc3a50d.png";